// extracted by mini-css-extract-plugin
export var articleTitle = "style-module--articleTitle--1e850";
export var controller = "style-module--controller--cc22f";
export var copy = "style-module--copy--8dda1";
export var cursor = "style-module--cursor--208f1";
export var description = "style-module--description--30069";
export var headline = "style-module--headline--80f00";
export var image = "style-module--image--eebc3";
export var images = "style-module--images--f5bb6";
export var link = "style-module--link--c8969";
export var main = "style-module--main--1f073";
export var sub = "style-module--sub--99ff6";